import {
  RepairSpecDataDto,
  RepairSpecDataInputDto,
  RepairSpecDetalizationType,
  RepairSpecDto,
  RepairSpecReferenceDto,
} from "@/core/api/generated/v1";

import { Mapper } from "../mapper";

/** Any entity DTO type according to @type EntityFormType */
export type RepairSpecDtoAny =
  | RepairSpecDto
  | RepairSpecReferenceDto
  | RepairSpecDataDto
  | RepairSpecDataInputDto
  | RepairSpecDataInputDtoLocal;

/** All entity DTO types according to @type EntityFormType */
export type RepairSpecDtoAll = RepairSpecDto &
  RepairSpecReferenceDto &
  RepairSpecDataDto &
  RepairSpecDataInputDto &
  RepairSpecDataInputDtoLocal;

/** Any entity data DTO type. */
export type RepairSpecDataDtoAny =
  | RepairSpecDataDto
  | RepairSpecDataInputDto
  | RepairSpecDataInputDtoLocal;

/** All entity data DTO types. */
export type RepairSpecDataDtoAll = RepairSpecDataDto &
  RepairSpecDataInputDto &
  RepairSpecDataInputDtoLocal;

export type RepairSpecDataInputDtoLocal = RepairSpecDataInputDto &
  RepairSpecDataDto & {
    // ... add extra local fields here
    placeholder?: unknown;
  };

export class RepairSpecMapper {
  public static mapToDataInputDto(source: RepairSpecDtoAny): RepairSpecDataInputDtoLocal {
    const source2 = source as RepairSpecDtoAll;
    return {
      ...source,
      id: source2.id || undefined,
      damageTypeId: source2.damageType?.id || source2.damageTypeId || undefined,
      partTypeId: source2.partType?.id || source2.partTypeId || undefined,
      spotFactor: source2.spotFactor ?? 1,
      detalization: {
        ...source2.detalization,
        type: source2.detalization?.type || RepairSpecDetalizationType.General,
        vehicleSize: source2.detalization?.vehicleSize || undefined,
        bodyType: source2.detalization?.bodyType || undefined,
        makeId: source2.detalization?.make?.id || source2.detalization?.makeId || undefined,
        modelId: source2.detalization?.model?.id || source2.detalization?.modelId || undefined,
        generationId:
          source2.detalization?.generation?.id || source2.detalization?.generationId || undefined,
        modificationId:
          source2.detalization?.modification?.id ||
          source2.detalization?.modificationId ||
          undefined,
      },
      items:
        source2.items?.map((item) => ({
          ...item,
          materialId: item.material?.id,
          workId: item.work?.id,
          sparePart:
            (item.sparePart && {
              sparePartId: item.sparePart?.sparePart?.id || undefined,
              currency:
                item.sparePart?.currency || item.sparePart?.sparePart?.currency || undefined,
              price: (item.sparePart?.price || item.sparePart?.sparePart?.price) ?? undefined,
              discount:
                item.sparePart?.discount || item.sparePart?.sparePart?.discount || undefined,
              tax: item.sparePart?.tax || item.sparePart?.sparePart?.tax || undefined,
              total: (item.sparePart?.total || item.sparePart?.sparePart?.total) ?? undefined,
            }) ||
            undefined,
          amount: item?.amount ?? 1,
          spotFactor: item?.spotFactor ?? 1,
          notes: item?.notes || undefined,
        })) || undefined,
    };
  }

  public static mapToDataInputDtoForBe(
    source: RepairSpecDataInputDtoLocal,
  ): RepairSpecDataInputDto {
    const dest: RepairSpecDataInputDtoLocal = {
      ...source,
      // ... reset extra local fields here
      placeholder: undefined,
    };
    return Mapper.baseEntity.mapToDataInputDtoForBe(dest);
  }
}
